import React from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface TrialModeModalProps {
    show: boolean;
    onHide: () => void;
}

/**
 * Modal that displays trial mode information and upgrade instructions.
 * Shows when users try to access paid features while in trial mode.
 */
const TrialModeModal: React.FC<TrialModeModalProps> = ({ show, onHide }) => {
    const { t } = useTranslation("common");

    const handleContactSupport = () => {
        window.open("mailto:support@sweap.io?subject=Ich%20interessiere%20mich%20f%C3%BCr%20den%20EventDocs", "_blank");
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("trialMode.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="warning" className="mb-3">
                    <Alert.Heading>{t("trialMode.heading")}</Alert.Heading>
                    <p className="mb-0">{t("trialMode.description")}</p>
                </Alert>

                <p>
                    {t("trialMode.contact")}{" "}
                    <a
                        href="mailto:support@sweap.io?subject=Ich%20interessiere%20mich%20f%C3%BCr%20den%20EventDocs"
                        target="_blank"
                    >
                        support@sweap.io
                    </a>
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t("buttons.close")}
                </Button>
                <Button variant="primary" onClick={handleContactSupport}>
                    {t("trialMode.contactSupport")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TrialModeModal;
